import { render, staticRenderFns } from "./MinMaxPreview.vue?vue&type=template&id=65c7b3fc&"
import script from "./MinMaxPreview.vue?vue&type=script&lang=js&"
export * from "./MinMaxPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports